import React from "react"
import styles from "./UserTabs.module.scss"

const UserTabs = ({ tabs, activeTab, setActiveTab, children }) => {
  return (
    <div className={styles['wrapper']}>
      <div className={styles['tabs-wrapper']}>
        {tabs.map((tab, index) => (
          <div key={index} className={`${styles.tab} ${tab === activeTab ? styles["tab-active"] : ""}`} onClick={() => setActiveTab(tab)}>
            {tab}
          </div>
        ))}
      </div>

      <div>{children}</div>
    </div>
  )
}

export default UserTabs
